import { render, staticRenderFns } from "./PriceguardExpiresAt.vue?vue&type=template&id=6704836b"
import script from "./PriceguardExpiresAt.vue?vue&type=script&lang=js"
export * from "./PriceguardExpiresAt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6704836b')) {
      api.createRecord('6704836b', component.options)
    } else {
      api.reload('6704836b', component.options)
    }
    module.hot.accept("./PriceguardExpiresAt.vue?vue&type=template&id=6704836b", function () {
      api.rerender('6704836b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceguardExpiresAt.vue"
export default component.exports